import type { FC } from 'react';
import { Inline } from '@george-labs.com/design-system';

import { HighlightCard } from '../components/HighlightCard';

type HighlightCardProps = Omit<Parameters<typeof HighlightCard>[0], 'value'>;

type Props = HighlightCardProps & {
    content: string;
};

export const TextHighlight: FC<Props> = ({
    icon,
    label,
    content,
    'data-cy': dataCy,
    valuePostfix,
    illustration,
}) => (
    <HighlightCard
        data-cy={dataCy}
        icon={icon}
        label={label}
        illustration={illustration}
        value={
            <Inline data-cy={`${dataCy}-highlight-text`} emphasis>
                {content}
            </Inline>
        }
        valuePostfix={valuePostfix}
    />
);
